import React from 'react';

const AppContext = React.createContext({});
export default AppContext;



// WEBPACK FOOTER //
// ./src/AppContext.js